












































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { EPaymentMethod } from '@/helpers/enums';
import { EBankSlipInstallmentSteps } from '@/shared/enums/EBankSlipInstallmentSteps';

import Divider from '@/shared/components/Divider/Divider.vue';
import Button from '@/shared/components/Button/Button.vue';

import Koin from './components/Koin/Koin.vue';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Divider,
    Button,
    Koin,
  }
})
export default class BankSlipContent extends Vue {
  @Prop()
  private readonly bankslip: any;

  @CheckoutModule.Getter('selectedOfferDiscountByPaymentMethod')
  private discountByPaymentMethod: any;

  @CheckoutModule.Getter
  private disableBankSlipInstallments: boolean;

  @CheckoutModule.Getter
  private readonly bankSlipStep!: string;

  @CheckoutModule.Getter
  private selectedOfferPaymentStructure!: any;

  @CheckoutModule.Getter
  private getOfferPaymentConditionByMethodCode!: any;

  @CheckoutModule.Mutation
  private readonly setKoinStepsActivated!: Function;

  @CheckoutModule.Mutation
  private setBankSlipInstallmentsStep!: Function;

  @CheckoutModule.Mutation
  private setBankSlipInstallment: Function;

  @CheckoutModule.Mutation
  private readonly setKoinOptinChecked!: Function;

  @CheckoutModule.State('offerLoading')
  private loading!: boolean;

  private get labelDiscount() {
    return this.$t(`App.Checkout.Payment.discount.paymentsMethods.${EPaymentMethod.bankSlip}`);
  }

  private get showLabelDiscount() {
    return this.discountByPaymentMethod(EPaymentMethod.bankSlip);
  }

  private get isEmpiricusGift() {
    return this.$route.query.g === '1';
  }

  private get bankSlipInstallmentSteps() {
    return EBankSlipInstallmentSteps;
  }

  private get showBankSlipInitial() {
    return this.bankSlipStep === this.bankSlipInstallmentSteps.initial;
  }

  private get paymentConditions() {
    return this.getOfferPaymentConditionByMethodCode(this.bankslip.method).payment_conditions;
  }

  private get paymentConditionBankSlip() {
    return this.paymentConditions && this.paymentConditions.find((value: any) => value.payment_method_code === this.bankslip.method);
  }

  private get showInstallment() {
    return this.paymentConditionBankSlip && this.paymentConditionBankSlip.min_installments_price > 99 && this.paymentConditionBankSlip.max_installments_number > 1;
  }

  private showKoinSteps() {
    this.setKoinStepsActivated(true);
    this.setBankSlipInstallmentsStep(this.bankSlipInstallmentSteps.optin);
  }

  private prepareBankSlipInstallments(payload: any) {
    this.$emit('prepareBankSlipInstallments', payload);
  }

  mounted() {
    this.setBankSlipInstallment(null);
    this.setKoinStepsActivated(false);
    this.setKoinOptinChecked(false);
    this.setBankSlipInstallmentsStep(this.bankSlipInstallmentSteps.initial);
  }
}
